import Vue from "vue";
const eventHub = new Vue();
export default {
    data() {
        return {
            eventHub: eventHub,
        };
    },
    methods: {
        $confirm($text, callback, $yesTxt = null, $noText = null) {
            this.eventHub.$on("confirm", () => {
                callback();
                this.eventHub.$off("confirm");
            });

            this.eventHub.$on("cancel", () => {
                this.eventHub.$off("cancel");
                this.eventHub.$off("confirm");
            });

            this.eventHub.$emit("update", { text: $text, yes: $yesTxt, no: $noText });
        },
    },
};
